/**
 * Partner feed mobile accordion
 */
import tabs from '../../../util/tabs'

const isMobile = () => window.innerWidth < 1080

export const partnersFeedAccordion = ({ elWrap }) => {
	// get all accordion buttons
	const buttons = elWrap.querySelectorAll('.partners-feed__control-button')
	// create tabs
	tabs('partners-feed', {
		selectors: {
			wrap: '.partners-feed__control--acc',
			toggles: '.partners-feed__control-button',
			content: '.partners-feed__control-options',
		},
	})
	// pre-activate tabs if we start at desktop (since they don't even look like accordions at this size)
	if (!isMobile()) {
		buttons.forEach((button) => {
			button.click()
		})
	}
	// collapse accordions on click of children for mobile
	document.addEventListener('facetwp-loaded', () => {
		if (isMobile()) {
			;[...buttons]
				.filter((button) => button.getAttribute('aria-selected') === 'true')
				.forEach((button) => {
					button.click()
				})
		}
	})
}
